import { render, staticRenderFns } from "./ShopsPaymentsRow.vue?vue&type=template&id=98fa813c&scoped=true&"
import script from "./ShopsPaymentsRow.vue?vue&type=script&lang=js&"
export * from "./ShopsPaymentsRow.vue?vue&type=script&lang=js&"
import style0 from "./ShopsPaymentsRow.vue?vue&type=style&index=0&id=98fa813c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fa813c",
  null
  
)

export default component.exports